module.exports = __webpack_public_path__ + "static/media/jeanFrancoisBelis.3a2e2793.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/jeanFrancoisBelis.jpg
// module id = 1675
// module chunks = 1